import { cn } from '@/lib/utils'

interface RadialGaugeProps {
  // 0-100, or null to show an undefined state ("—").
  value: number | null
  size?: number
  label?: string
  className?: string
}

// Figma Progress circle (850:8885): 140×140, stroke 16, round caps.
export function RadialGauge({
  value,
  size = 140,
  label,
  className,
}: RadialGaugeProps) {
  const stroke = 16
  const radius = (size - stroke) / 2
  const circumference = 2 * Math.PI * radius
  const pct = value === null ? 0 : Math.min(100, Math.max(0, value))
  const offset = circumference - (pct / 100) * circumference
  const display = value === null ? '—' : `${Math.round(pct)}%`

  return (
    <div
      className={cn('relative inline-flex', className)}
      style={{ width: size, height: size }}
    >
      <svg width={size} height={size} className='-rotate-90'>
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill='none'
          stroke='#e7e9ef'
          strokeWidth={stroke}
          strokeLinecap='round'
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill='none'
          stroke='#10b981'
          strokeWidth={stroke}
          strokeLinecap='round'
          strokeDasharray={circumference}
          strokeDashoffset={offset}
        />
      </svg>
      <div className='absolute inset-0 flex flex-col items-center justify-center'>
        <span className='font-heading text-xl font-bold leading-[1.2] text-[#171a20]'>
          {display}
        </span>
        {label && (
          <span className='text-xs text-muted-foreground'>{label}</span>
        )}
      </div>
    </div>
  )
}

export default RadialGauge
